import { isFilesSizeValid } from 'CorePackage/MainModule/validators/isFilesSizeValid';
import { UploadFile } from 'UIPackage/MainModule/components/UploadFile';
import { IUploadFile } from 'CorePackage/MainModule/interfaces/IUploadFile';

import styles from './UploadStatus.module.scss';

export interface IUploadStatusProps {
  className?: string;
  files: IUploadFile[];
  removeFile: (fileName: string) => void;
  setError: (error: string) => void;
}

export const UploadStatus = ({ className = '', files, removeFile, setError }: IUploadStatusProps) => {
  const onRemove = (fileName: string) => () => {
    isFilesSizeValid(files.filter(file => file.fileName !== fileName)) && setError('');
    removeFile(fileName);
  };

  if (!files.length) {
    return null;
  }

  return (
    <div className={className}>
      {files.map(file => (
        <UploadFile
          key={file.fileName}
          className={styles.File}
          fileName={file.fileName}
          fileSize={file.fileSize}
          fileType={file.fileType}
          progress={file.progress}
          error={file.error}
          onRemove={onRemove(file.fileName)}
        />
      ))}
    </div>
  );
};
